import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const payerPlanApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPayerPlans: builder.query({
      query: filters => {
        const qs = Object.keys(filters).reduce((acc, k) => {
          acc.set(k, filters[k]);
          return acc;
        }, new URLSearchParams());
        return `payer_plan/?${qs}`;
      },
      providesTags: ['PayerPlan', 'Payer', 'Patient', 'Location'],
    }),
    createPayerPlan: builder.mutation({
      query: body => ({
        url: 'payer_plan/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['PayerPlan', 'Payer', 'Patient'],
    }),
    updatePayerPlan: builder.mutation({
      query: ({id, body}) => ({
        url: `payer_plan/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['PayerPlan', 'Payer', 'Patient', 'Location'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPayerPlansQuery, 
  useCreatePayerPlanMutation, 
  useUpdatePayerPlanMutation,
} = payerPlanApi;
